import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useInView } from 'react-intersection-observer';

import { Text, Preset, FunctionColor } from '@lux/text';
import { Media, SnakeToCamelObject } from '@browsing/api';
import { Campaign } from '@shared/types/mylounge';
import { getCategoryTabId } from '@client/redux/modules/mylounge';
import { buildCampaignUrl } from '@client/helpers/campaignUrl';

import Discount from './discount';

interface CampaignCardBaseProps {
    campaign: Campaign;
    media: Omit<SnakeToCamelObject<Media>, 'path'>;
    onClick?: () => void;
    index: number;
    onInView?: (campaign: Campaign, isVisible: boolean) => void;
}

const CampaignCardCompact = ({ campaign, media, onClick, onInView }: CampaignCardBaseProps) => {
    const { campaignId } = campaign;
    const categoryTabId = useSelector(getCategoryTabId);
    const destination = buildCampaignUrl(campaign.campaignId, categoryTabId);

    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: false,
    });

    useEffect(() => {
        if (onInView) {
            onInView(campaign, inView);
        }
    }, [inView, campaign, onInView]);

    return (
        <a
            ref={ref}
            id={campaignId}
            href={destination}
            onClick={onClick}
            className="bg-function-0 flex h-full flex-col"
        >
            <div className="relative aspect-square w-full">
                <img className="h-full w-full object-cover" src={media.url} alt={media.altText} />
            </div>
            <div className="pt-xs pr-xs pb-s pl-xs flex flex-grow flex-col">
                <div className="mb-xs line-clamp-2 w-full flex-1 text-start">
                    <Text preset={Preset.S} color={FunctionColor.function100} bold>
                        {campaign.name}
                    </Text>
                </div>
                <Discount campaign={campaign} cardVariant="compact" />
            </div>
        </a>
    );
};

export { CampaignCardCompact };
